/**
 * Common slice — holds app-wide UI state that doesn't fit a more specific slice.
 * currentRouteKey is read by layouts to highlight the active nav item and to
 * guard route-specific behaviour; it must be set whenever the active route changes.
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from './constants'

export type CommonState = {
    currentRouteKey: string
}

export const initialState: CommonState = {
    currentRouteKey: '',
}

export const commonSlice = createSlice({
    name: `${SLICE_BASE_NAME}/common`,
    initialState,
    reducers: {
        setCurrentRouteKey: (state, action: PayloadAction<string>) => {
            state.currentRouteKey = action.payload
        },
    },
})

export const { setCurrentRouteKey } = commonSlice.actions

export default commonSlice.reducer
